<ng-container>
  <div class="app-width-limit">
  <mat-sidenav-container *ngIf="isBookingEnabled">
    <mat-sidenav #sideNav>
      <mat-list>
        <mat-list-item *ngIf="showHome">
          <mat-divider></mat-divider>
          <button mat-button (click)="viewHomePage()">
            <mat-icon>home</mat-icon> {{ 'NAV.HOME' | translate }}
          </button>
        </mat-list-item>
        <mat-list-item
          *ngIf="isBookingEnabled && booking.getServices().length != 0"
        >
          <mat-divider></mat-divider>
          <button mat-button (click)="newBooking()">
            <mat-icon>add</mat-icon> {{ 'NAV.NEW_BOOKING' | translate }}
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="this.userService.isLoggedIn()">
          <button mat-button (click)="viewClientBookings()">
            <mat-icon>date_range</mat-icon>
            {{ 'NAV.YOUR_BOOKINGS' | translate }}
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="this.userService.isLoggedIn()">
          <button mat-button (click)="viewClientProfile()">
            <mat-icon>person</mat-icon>
            {{ 'NAV.YOUR_PROFILE' | translate }}
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="isBookingEnabled">
          <button mat-button (click)="viewHelpPage()">
            <mat-icon>help</mat-icon>
            {{ 'NAV.HELP' | translate }}
          </button>
        </mat-list-item>
        <mat-list-item *ngIf="isBookingEnabled">
          <button mat-button (click)="viewContactPage()">
            <mat-icon>phone</mat-icon>
            {{ 'NAV.CONTACT' | translate }}
          </button>
        </mat-list-item>
      </mat-list>
    </mat-sidenav>

    <mat-toolbar>
      <div fxLayout="row">
        <button
          mat-icon-button
          fxShow="false"
          fxShow.xs="true"
          fxShow.sm="true"
          (click)="sideNav.open()"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <button
          mat-button
          (click)="viewHomePage()"
          *ngIf="
            booking.getServices().length === 0 &&
            !router.url.includes('/bookings')
          "
        >
          <mat-icon>home</mat-icon> {{ 'NAV.HOME' | translate }}
        </button>
        <button
          mat-button
          (click)="newBooking()"
          *ngIf="
            (isBookingEnabled &&
            booking.getServices().length != 0) ||
            router.url.startsWith('/client/bookings')
          "
        >
          <mat-icon>add</mat-icon> {{ 'NAV.NEW_BOOKING' | translate }}
        </button>
        <button
          mat-button
          fxShow.xs="false"
          fxShow.sm="false"
          *ngIf="this.userService.isLoggedIn()"
          (click)="viewClientBookings()"
        >
          <mat-icon>date_range</mat-icon>
          {{ 'NAV.YOUR_BOOKINGS' | translate }}
        </button>

        <button
          mat-button
          fxShow.xs="false"
          fxShow.sm="false"
          *ngIf="this.userService.isLoggedIn()"
          (click)="viewClientProfile()"
        >
          <mat-icon>contact_mail</mat-icon>
          {{ 'NAV.YOUR_PROFILE' | translate }}
        </button>
        <button
          mat-button
          fxShow.xs="false"
          fxShow.sm="false"
          *ngIf="isBookingEnabled"
          (click)="viewHelpPage()"
        >
          <mat-icon>help</mat-icon>
          {{ 'NAV.HELP' | translate }}
        </button>
        <button
          mat-button
          fxShow.xs="false"
          fxShow.sm="false"
          *ngIf="isBookingEnabled"
          (click)="viewContactPage()"
        >
          <mat-icon>phone</mat-icon>
          {{ 'NAV.CONTACT' | translate }}
        </button>

        <span fxFlex="auto"></span>

        <app-language-selector></app-language-selector>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onLogOut()">{{ 'NAV.LOG_OUT' | translate }}</button>
        </mat-menu>

        <button
          *ngIf="this.userService.isLoggedIn()"
          mat-button
          [matMenuTriggerFor]="menu"
          class="smc-menu-login"
        >
          <mat-icon>person</mat-icon>
          {{
            this.userService.getUser().getFirstName() +
              ' ' +
              this.userService.getUser().getLastName()
          }}
        </button>

        <button
          *ngIf="!this.userService.isLoggedIn()"
          mat-button
          fxFlexAlign="end"
          (click)="onLogin()"
          class="smc-menu-login"
        >
          <mat-icon>person</mat-icon> {{ 'NAV.LOGIN' | translate }}
        </button>
      </div>
    </mat-toolbar>

    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

    <router-outlet></router-outlet>
    <salonmonster-footer *ngIf="showFooter"></salonmonster-footer>
  </mat-sidenav-container>
  <div class="text-center" *ngIf="!isBookingEnabled && !isLoading">
    <div id="no-online-booking">
      <img
        src="https://salonmonster.com/images/online-booking.png"
        class="no-online-booking-image"
      />
      <h2>{{ 'APP.BOOKING_DISABLED' | translate }}</h2>
      <h3 *ngIf="salon?.phone">{{ 'APP.CONTACT_US_AT' | translate:{ phone: salon.phone } }}</h3>
    </div>
  </div>

  <!-- Cookie Consent Banner -->
  <div *ngIf="showCookieBanner" class="cookie-banner">
    <div class="cookie-content">
      {{ 'COOKIE.BANNER_TEXT' | translate }}
      <a href="https://salonmonster.com/privacy-policy/" target="_blank">{{ 'COOKIE.POLICY_LINK' | translate }}</a>.
    </div>
    <button class="cookie-accept-btn" (click)="acceptCookies()">{{ 'COOKIE.ACCEPT' | translate }}</button>
  </div>
  </div>
</ng-container>
